import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';

const UserRoleDeleteConfirm = ({
  onDelete,
  loading,
  visible,
  onClose,
  role,
}) => {
  return (
    <Dialog
      fullWidth
      open={visible}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='sm'
    >
      <DialogTitle
        id='alert-dialog-title'
        fontSize={18}
        display={'flex'}
        justifyContent={'space-between'}
      >
        Delete Role?
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        Are you sure to delete Role{' '}
        <Box component='span' sx={{ fontWeight: 'bold' }}>
          {role?.Name}
        </Box>
        ?
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='secondary'>
          Close
        </Button>
        <LoadingButton
          color='error'
          variant='contained'
          loading={loading}
          onClick={() => onDelete({ roleId: role?.RoleId })}
        >
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(UserRoleDeleteConfirm);

UserRoleDeleteConfirm.propTypes = {};
